import React, { useMemo } from 'react';
import * as echarts from 'echarts';
import { transChannel } from '@/pages/opinion/utils';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import {
  formatChartParamsDate,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { getChartBufferWidth } from '@op/utils/systemUtil';

/**
 * TODO: 其他系统使用
 * 小图表组件
 * @param param0
 * @returns
 */
export default function Chart({
  statistics = { x: [], y: [] },
  text,
  formatValueFunc,
  dateType,
  name,
}: {
  statistics?: { x: never[]; y: never[] } | undefined;
  text: any;
  formatValueFunc: any;
  dateType: any;
  name: string;
}) {
  const options = useMemo(() => {
    let legendData: {
      name: string;
      itemStyle: {
        color: string;
      };
    }[] = [];
    let xAxisData: string[] = statistics?.x || [];
    let seriesData: any[] = [
      {
        symbol: 'circle',
        symbolSize: 0,
        data: statistics?.y || [],
        type: 'line',
        lineStyle: {
          width: 2,
          color: '#376AE7',
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(55, 106, 231, 0.3)',
            },
            {
              offset: 1,
              color: 'rgba(209,230,250,0.00)',
            },
          ]),
        },
      },
    ];

    const option = {
      tooltip: {
        appendToBody: true,
        position: function () {
          return { top: -80, right: -10 };
        },
        confine: false,
        formatter: (param: any) => {
          let { axisValue } = param?.[0] || {};
          return formatChartParamsDate({
            params: param,
            listTitleFunc: () => name,
            valueFormat: formatValueFunc,
            tablesConfigFunc: (records: Array<any>) => [
              {
                showHeader: true,
                records,
                columns: [
                  {
                    key: 'text',
                    header: text,
                  },
                  {
                    key: 'value',
                    align: 'right',
                    weight: 'bold',
                    header: listTimeTitleFunc(axisValue, dateType),
                  },
                ],
              },
            ],
          });
        },
      },
      legend: {
        data: legendData,
        formatter: (params: any) => {
          return transChannel(params);
        },
      },
      grid: {
        top: '5px',
        left: getChartBufferWidth(5),
        right: '5px',
        bottom: '5px',
        containLabel: false,
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: 0,
          data: xAxisData,
          axisLabel: false,
          axisLine: false,
          axisTick: false,
          splitLine: false,
        },
      ],
      yAxis: {
        type: 'value',
        splitLine: false,
        axisLabel: false,
        boundaryGap: 0,
      },
      series: seriesData,
    };

    return option;
  }, [statistics, name]);

  return (
    <EChartCommon
      options={options}
      height={30}
      optionsProps={{ excludeOptions: ['axisPointer'] }}
    ></EChartCommon>
  );
}
